<template>
  <v-row>
    <v-col cols="12" v-for="(item, i) in localIdentityCardParent.list" :key="i">
      <IdentityCardDocComponent
        :index="i"
        :item="item"
        @set-data="setIdentityCard($event, item)"
        @remove="removeIdentityCard(item)"
      />
    </v-col>

    <v-col
      cols="12"
      class="d-flex justify-end pt-0"
      v-if="!localIdentityCardParent.list.length"
    >
      <v-btn
        color="primary"
        outlined
        rounded
        @click="addIdentityCard"
      >
        <v-icon left>
          mdi-plus
        </v-icon>
        Добавить документ удостоверяющий личность
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import Title from '@/components/ui/Title'
import IdentityCardDocComponent from '@/components/zvp/application-create/identity-card-doc/IdentityCardDoc'
import {IdentityCardParent, IdentityCard} from '@/models'
import _cloneDeep from "lodash/cloneDeep";

export default {
  name: "IdentityCardDoc",

  components: {
    Title,
    IdentityCardDocComponent
  },

  props: {
    item: IdentityCardParent
  },

  data: () => ({
    localIdentityCardParent: new IdentityCardParent(),
  }),

  computed: {},

  methods: {
    addIdentityCard() {
      this.localIdentityCardParent.list.push(new IdentityCard())
    },

    setIdentityCard(event, item) {
      item.setProperties(event)
      this.$emit('set-data', this.localIdentityCardParent)
    },

    removeIdentityCard(item) {
      this.$emit('remove', item)
      //this.localIdentityCardParent.remove(item)
    },
  },

  watch: {
    'item.list': {
      immediate: true,
      deep: true,
      handler(value) {
        this.localIdentityCardParent = _cloneDeep(this.item)
        if (!value?.length) this.addIdentityCard()
      }
    }
  }
}
</script>

<style scoped>
</style>
